// ============================================
// Prenta — Dark Theme with Maker Aesthetic
// ============================================
// Orange/amber accents (warmth of creation/fabrication)

export const theme = {
  // Backgrounds
  bg: '#0a0a0f',
  bgCard: '#141419',
  bgInput: '#1a1a22',
  bgHover: '#1e1e28',
  bgModal: '#0d0d14',

  // Text
  text: '#e0e0e0',
  textSecondary: '#888899',
  textMuted: '#555566',

  // Accent — Warm orange/amber for maker aesthetic
  accent: '#f59e0b',       // Primary amber
  accentHover: '#d97706',
  accentLight: '#fbbf24',
  accentBg: 'rgba(245, 158, 11, 0.1)',

  // Status colors
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',

  // Borders
  border: '#2a2a35',
  borderLight: '#333344',

  // Category colors
  categories: {
    '3d_print': '#8b5cf6',   // Violet
    laser: '#ef4444',         // Red
    cnc: '#3b82f6',           // Blue
    handcraft: '#10b981',     // Emerald
    sewing: '#ec4899',        // Pink
    paint: '#f59e0b',         // Amber
    woodwork: '#92400e',      // Brown
    metalwork: '#6b7280',     // Gray
    electronics: '#06b6d4',   // Cyan
    other: '#8b5cf6',         // Purple
  },

  // Sizing
  maxWidth: '480px',
  radius: '12px',
  radiusSm: '8px',
  touchTarget: '44px',
};
